const { CONSTANTS } = require('../../../../config')

/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function ssn ({ value, validationValue }) {
  if (!validationValue) return true

  let val = value
  if (!val) return false

  val = val
    .toString()
    .trim()

  // Remove all characters except numbers
  val = val.replace(/[^0-9]/g, '')
  if (val.length !== 11) return false

  const individualNumber = value.substring(6, 9)
  let year = value.substring(4, 6)
  const month = val.substring(2, 4)
  const day = val.substring(0, 2)

  if (month < 1 || month > 12) return false
  if (day < 1 || day > 71) return false // Account for D-number, which is day of birth + 40.

  if (individualNumber >= 500) {
    year = `20${year}`
  } else {
    year = `19${year}`
  }

  const currentDate = new Date()
  const birthDate = new Date(parseInt(year, 10), (month - 1), parseInt(day, 10))
  const timeDiff = Math.abs(currentDate.getTime() - birthDate.getTime())
  const ageDate = new Date(timeDiff)
  const age = Math.abs(ageDate.getUTCFullYear() - 1970)

  // Check valid date
  /* istanbul ignore next: really hard to produce error */
  if (Object.prototype.toString.call(birthDate) !== '[object Date]' || isNaN(birthDate.getTime())) return false

  // Check if younger than min age
  if (age < CONSTANTS.NO?.AGE?.MIN) return false

  // Check if older than max age
  if (age > CONSTANTS.NO?.AGE?.MAX) return false

  // Start verification of checksum
  const staticSequenceFirstCheckDigit = [3, 7, 6, 1, 8, 9, 4, 5, 2, 1]
  const staticSequenceSecondCheckDigit = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1]

  let firstCheckValidatorSum = 0
  let secondCheckValidatorSum = 0

  for (let i = 0; i < staticSequenceFirstCheckDigit.length; i++) {
    firstCheckValidatorSum += val[i] * staticSequenceFirstCheckDigit[i]
  }
  for (let i = 0; i < staticSequenceSecondCheckDigit.length; i++) {
    secondCheckValidatorSum += val[i] * staticSequenceSecondCheckDigit[i]
  }

  return !(firstCheckValidatorSum % 11 !== 0 || secondCheckValidatorSum % 11 !== 0)
}

module.exports = { ssn }
